'use client';

import { useRouter } from 'next/navigation';

import { useAuth } from '@flipster/features/src/shared/auth/state';
import { Button } from '@flipster/react/design-system';

import { useSpookyTreatsFestivalLuckyDraw } from '../useLuckyDraw';

export const TopButton = () => {
  const { isRegistered, registerLuckyDraw, status } = useSpookyTreatsFestivalLuckyDraw();
  const { isLoggedIn } = useAuth();
  const router = useRouter();

  if (status === 'FINISHED') return <Button size='large' label='Trade now' onClick={() => router.push('/trade')} />;

  if (!isLoggedIn) return <Button size='large' label='Sign up now' onClick={() => registerLuckyDraw()} />;

  if (isLoggedIn && !isRegistered)
    return (
      <Button size='large' label='Register now' onClick={() => registerLuckyDraw()} disabled={status === 'UPCOMING'} />
    );

  return <Button size='large' label='Trade for treats' onClick={() => router.push('/trade')} />;
};
